import ApiProductsHOC from "../../containers/ApiProductsListHOC";
import ApiProductHOC from "../../containers/ApiProductHOC";
import ApiDocumentationHOC from "../../containers/ApiDocumentationHOC";
import SwaggerPageHOC from "../../containers/SwaggerPageHOC";
import APIProductServiceTest from "../../components/apiProductServiceTest/APIProductServiceTest";
import SwaggerTestPage from "../../components/swaggerTest/SwaggerTestPage";

export const ROUTE_API_ENDPOINT_DOCUMENTATION = {
  path: "/documentation/:combinedParam",
  component: ApiDocumentationHOC,
  key: "api.endpoint.documentation",
};

export const ROUTE_PRODUCT_DOCUMENTATION = {
  path: "/documentation/:productId/:apiName",
  component: ApiDocumentationHOC,
  key: "product.view.documentation",
};

export const ROUTE_PRODUCT_VIEW_ALL = {
  path: "/apiProducts",
  component: ApiProductsHOC,
  name: "Products",
  key: "product.view.all",
};

export const ROUTE_PRODUCT_VIEW_SINGLE = {
  path: "/apiProduct/:apiProductId/:viewMode?",
  component: ApiProductHOC,
  key: "product.view.single",
};

export const ROUTE_SWAGGER_PAGE = {
  path: "/apiProduct/:apiProductId/swagger/:apiName",
  component: SwaggerPageHOC,
  key: "product.swagger",
};

export const ROUTE_SWAGGER_PAGE_ALT = {
  path: "/swagger/:apiName",
  component: SwaggerPageHOC,
  key: "product.swagger.alt",
};

export const ROUTE_API_PRODUCT_SERVICE_TEST = {
  path: "/test/api-product-service",
  component: APIProductServiceTest,
  key: "test.api.product.service",
};

export const ROUTE_SWAGGER_TEST = {
  path: "/test/swagger-entities",
  component: SwaggerTestPage,
  key: "test.swagger.entities",
};

export const PRODUCT_ROUTES = [
  ROUTE_PRODUCT_DOCUMENTATION, // Two params - more specific, must come first
  ROUTE_API_ENDPOINT_DOCUMENTATION, // One param - less specific
  ROUTE_PRODUCT_VIEW_ALL,
  // Developer test pages: only in `vite dev`, never in a built bundle (QA/production).
  ...(import.meta.env.DEV
    ? [ROUTE_API_PRODUCT_SERVICE_TEST, ROUTE_SWAGGER_TEST]
    : []),
  ROUTE_SWAGGER_PAGE, // Must come before ROUTE_PRODUCT_VIEW_SINGLE
  ROUTE_SWAGGER_PAGE_ALT,
  ROUTE_PRODUCT_VIEW_SINGLE, // This comes last due to its optional :viewMode parameter
];
